import processPipe from './processPipe';

function getsecondYearFeeforBusCategory(options) {
  const { monthsFromNow } = options;
  const pipe = processPipe(options.pipe);

  const svc = Number(options.svc);
  const rset = pipe[`r${monthsFromNow}`];

  const Z = Number(options.vehicleWeight || 0);
  const K = rset;
  const W = Math.round(Z / 100);
  const classCode = Number(pipe.r22);
  let secondYear = 0;

  if (monthsFromNow > 3) {
  // 36 Buses, (All except private school bus)
    if ((K === 'b') && (Z !== 0)) {
      secondYear = (((((17.00) + (2.00 * W)) / 12) * 12) + (svc));
    }

  // 36 Bus 6 month semiannual except private school bus
    if (K === 's' && Z !== 0) {
    // $2.50 semi-annual fee added in fee change and 11.60
    // due to partial fees (ARF etc) for 6 month period
      secondYear = 0;
    }

  // 53 Trailers Private Use over 500 lbs
    if (((K === 't') && ((Z !== 0) && (Z > 500)))) {
      secondYear = (((((3.50) + (1.00 * W)) / 12) * 12) + (svc));
    }

  // 360 is 6-month semiannual buses
    if (classCode === 360) {
      alert('not eligible for biennial (2nd year) renewal');
      secondYear = 0;
    }
  } else {
    alert('Number of Months chosen above should be more than 3 instead of adding biennial fees (choose 13 to 15 months)');
    secondYear = 0;
  }

  return secondYear;
}

export default getsecondYearFeeforBusCategory;
